import { Component, type ReactNode } from "react";
import { w } from "../i18n";

/** Contains a render error to the page that raised it, with a way back. */
export class PageBoundary extends Component<{ children: ReactNode; resetKey: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("workspace page failed to render", error);
  }

  componentDidUpdate(previous: { resetKey: string }) {
    if (previous.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <div className="ws-alert ws-tone-negative" role="alert"><div>
      <h3>{w("boundary.title")}</h3>
      <p>{w("boundary.body")}</p>
      <div className="ws-alert-actions"><button className="ws-btn sm" onClick={() => this.setState({ error: null })}>{w("common.retry")}</button></div>
    </div></div>;
  }
}
